import { z } from 'zod'

export const RegisterSchema = z.object({
    first_name: z.string().min(1, 'Votre prénom est requis'),
    last_name: z.string().min(1, 'Votre nom est requis'),
    phone: z.union([z.string().regex(/^\d+$/), z.undefined(), z.null()]),
    email: z.string().email("L'adresse email n'est pas valide"),
    password: z
        .string()
        .min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
})
